import React from "react";
import styled from "styled-components";

const AboutLink = styled.a`
  color: #010f7a;
  text-decoration: none;
  padding: 1px 0px;
  transition: background 0.05s ease, color 0.05s ease;

  &:visited {
    color: #010f7a;
  }

  &:hover {
    background: #000080;
    color: #fff;
  }

  &:active {
    background: #000060;
    color: #fff;
  }
`;

function About() {
  return (
    <div>
      <h2>Vishal Shenoy</h2>
      <p>
        I work on engineering deployments at{" "}
        <AboutLink
          href="https://www.rox.com/"
          target="_blank"
          rel="noreferrer"
        >
          Rox
        </AboutLink>
        .

        <span style={{ display: "block", height: "0.8em" }} />

        Previously, I held engineering roles at startups{" "}
        <AboutLink
          href="https://codegen.com"
          target="_blank"
          rel="noreferrer"
        >
          Codegen
        </AboutLink>{" "}
        and{" "}
        <AboutLink
          href="https://tenstorrent.com"
          target="_blank"
          rel="noreferrer"
        >
          Tenstorrent
        </AboutLink>
        , and at venture firm{" "}
        <AboutLink
          href="https://conviction.com"
          target="_blank"
          rel="noreferrer"
        >
          Conviction Partners
        </AboutLink>
        . I also did research on training simulation at{" "}
        <AboutLink
          href="https://med.stanford.edu/biodesign.html"
          target="_blank"
          rel="noreferrer"
        >
          Stanford Medicine
        </AboutLink>.
        <span style={{ display: "block", height: "0.8em" }} />
        I grew up in the Bay Area, studied computer science at{" "}
        <AboutLink
        href="https://ucdavis.edu"
        target="_blank"
        rel="noreferrer"

        >

        UCD</AboutLink>, and now live in San Francisco.

      </p>
    </div>
  );
}

export default About;
